<fa-icon *ngIf="hint" [icon]="hintIcon" [pTooltip]="hint" [tooltipPosition]="hintPosition"></fa-icon>
